export default "__VITE_ASSET__36d4341b__"